import dayjs from '@/helpers/dayjs'

function formatSlotDate(date: Date | string, duration = 0) {
  const startDate = dayjs(date)
  const endDate = startDate.add(duration, 'seconds')
  const timeframe = `${startDate.format('HH:mm')} - ${endDate.format('HH:mm')}`

  const eventDate = startDate.format('dd. D MMM')

  return { eventDate, timeframe }
}

export default formatSlotDate
